import { render, staticRenderFns } from "./FaturaView.vue?vue&type=template&id=1c04ba68&"
import script from "./FaturaView.vue?vue&type=script&lang=js&"
export * from "./FaturaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports